import FaqView from "@/components/app/FaqView";
export default function FaqResidents() {
  return <FaqView kind="residents" title="FAQs for Residents" accent="btn-moss" />;
}
